var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h5',[_vm._v("Page introuvable")])])}
var staticRenderFns = []

export { render, staticRenderFns }